import React from "react";
import PropTypes from "prop-types";
import { Route } from "react-router-dom";
import { LS_FIELD_JWT } from "../../constants";

const Authmiddleware = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  showProfileSideBar,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => {
      if (isAuthProtected && !localStorage.getItem(LS_FIELD_JWT)) {
        props?.history?.push?.("/");
        props?.history?.go?.();
        return <></>;
      }
      return (
        <Layout>
          <Component {...props} showProfileSideBar={showProfileSideBar}/>
        </Layout>
      );
    }}
  />
);

Authmiddleware.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any,
};

export default Authmiddleware;
